import { render, staticRenderFns } from "./viewRegionalDirectorDetails.vue?vue&type=template&id=1e67ba42&"
import script from "./viewRegionalDirectorDetails.vue?vue&type=script&lang=js&"
export * from "./viewRegionalDirectorDetails.vue?vue&type=script&lang=js&"
import style0 from "./viewRegionalDirectorDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports